export const dataDashboardConstants = {
  CHANGE_ASSESSMENT_ID: "CHANGE_DD_ASSESSMENT_ID",
  CHANGE_EXIT_TICKET_ID: "CHANGE_DD_EXIT_TICKET_ID",
  CHANGE_COMPARE_MODE: "CHANGE_DD_COMPARE_MODE",
  CHANGE_SWAP: "CHANGE_DD_SWAP",
  CHANGE_YEAR: "CHANGE_YEAR",

  FETCH_EXTERNAL_TESTS_BY_SUBTYPE: "FETCH_EXTERNAL_TESTS_BY_SUBTYPE",
  FETCH_EXTERNAL_TESTS_BY_SUBTYPE_SUCCESS:
    "FETCH_EXTERNAL_TESTS_BY_SUBTYPE_SUCCESS",
  FETCH_EXTERNAL_TESTS_BY_SUBTYPE_ERROR:
    "FETCH_EXTERNAL_TESTS_BY_SUBTYPE_ERROR",

  STORE_EXTERNAL_TESTS_STUDENT: "STORE_EXTERNAL_TESTS_STUDENT",
  STORE_EXTERNAL_TESTS_STUDENT_SUCCESS: "STORE_EXTERNAL_TESTS_STUDENT_SUCCESS",
  STORE_EXTERNAL_TESTS_STUDENT_ERROR: "STORE_EXTERNAL_TESTS_STUDENT_ERROR",

  FETCH_EXTERNAL_SUPPORT: "FETCH_EXTERNAL_SUPPORT",
  FETCH_EXTERNAL_SUPPORT_SUCCESS: "FETCH_EXTERNAL_SUPPORT_SUCCESS",
  FETCH_EXTERNAL_SUPPORT_ERROR: "FETCH_EXTERNAL_SUPPORT_ERROR",

  ADD_STUDENT_EXTERNAL_SUPPRORT: "ADD_STUDENT_EXTERNAL_SUPPRORT",
  ADD_STUDENT_EXTERNAL_SUPPRORT_SUCCESS:
    "ADD_STUDENT_EXTERNAL_SUPPRORT_SUCCESS",
  ADD_STUDENT_EXTERNAL_SUPPRORT_ERROR: "ADD_STUDENT_EXTERNAL_SUPPRORT_ERROR",

  FETCH_ALL_STUDENTS_EXTERNAL_SUPPORT: "FETCH_ALL_STUDENTS_EXTERNAL_SUPPORT",
  FETCH_ALL_STUDENTS_EXTERNAL_SUPPORT_SUCCESS:
    "FETCH_ALL_STUDENTS_EXTERNAL_SUPPORT_SUCCESS",
  FETCH_ALL_STUDENTS_EXTERNAL_SUPPORT_ERROR:
    "FETCH_ALL_STUDENTS_EXTERNAL_SUPPORT_ERROR",

  FETCH_EXTERNAL_SUPPORTS_GROUPS: "FETCH_EXTERNAL_SUPPORTS_GROUPS",
  FETCH_EXTERNAL_SUPPORTS_GROUPS_SUCCESS:
    "FETCH_EXTERNAL_SUPPORTS_GROUPS_SUCCESS",
  FETCH_EXTERNAL_SUPPORTS_GROUPS_ERROR: "FETCH_EXTERNAL_SUPPORTS_GROUPS_ERROR",

  DELETE_STUDENT_EXTERNAL_SUPPORT: "DELETE_STUDENT_EXTERNAL_SUPPORT",
  DELETE_STUDENT_EXTERNAL_SUPPORT_SUCCESS:
    "DELETE_STUDENT_EXTERNAL_SUPPORT_SUCCESS",
  DELETE_STUDENT_EXTERNAL_SUPPORT_ERROR:
    "DELETE_STUDENT_EXTERNAL_SUPPORT_ERROR",

  GET_EXTERNAL_TEST_GROUP: "GET_EXTERNAL_TEST_GROUP",
  GET_EXTERNAL_TEST_GROUP_SUCCESS: "GET_EXTERNAL_TEST_GROUP_SUCCESS",
  GET_EXTERNAL_TEST_GROUP_FAILURE: "GET_EXTERNAL_TEST_GROUP_FAILURE",

  GET_EXTERNAL_TEST_STUDENT: "GET_EXTERNAL_TEST_STUDENT",
  GET_EXTERNAL_TEST_STUDENT_SUCCESS: "GET_EXTERNAL_TEST_STUDENT_SUCCESS",
  GET_EXTERNAL_TEST_STUDENT_FAILURE: "GET_EXTERNAL_TEST_STUDENT_FAILURE",

  UPDATE_EXTERNAL_TEST_GROUP: "UPDATE_EXTERNAL_TEST_GROUP",
  UPDATE_EXTERNAL_TEST_GROUP_SUCCESS: "UPDATE_EXTERNAL_TEST_GROUP_SUCCESS",
  UPDATE_EXTERNAL_TEST_GROUP_FAILURE: "UPDATE_EXTERNAL_TEST_GROUP_FAILURE",

  UPDATE_EXTERNAL_SUPPORT_GROUP: "UPDATE_EXTERNAL_SUPPORT_GROUP",
  UPDATE_EXTERNAL_SUPPORT_GROUP_SUCCESS:
    "UPDATE_EXTERNAL_SUPPORT_GROUP_SUCCESS",
  UPDATE_EXTERNAL_SUPPORT_GROUP_FAILURE:
    "UPDATE_EXTERNAL_SUPPORT_GROUP_FAILURE",

  GET_ALL_EXTERNAL_TEST: "GET_ALL_EXTERNAL_TEST",
  GET_ALL_EXTERNAL_TEST_SUCCESS: "GET_ALL_EXTERNAL_TEST_SUCCESS",
  GET_ALL_EXTERNAL_TEST_FAILURE: "GET_ALL_EXTERNAL_TEST_FAILURE",

  DELETE_ALL_STUDENTS_EXTERNAL_SUPPORTS:
    "DELETE_ALL_STUDENTS_EXTERNAL_SUPPORTS",
  DELETE_ALL_STUDENTS_EXTERNAL_SUPPORTS_SUCCESS:
    "DELETE_ALL_STUDENTS_EXTERNAL_SUPPORTS_SUCCESS",
  DELETE_ALL_STUDENTS_EXTERNAL_SUPPORTS_ERROR:
    "DELETE_ALL_STUDENTS_EXTERNAL_SUPPORTS_ERROR",

  ADD_ALL_STUDENTS_EXTERNAL_SUPPORT: "ADD_ALL_STUDENTS_EXTERNAL_SUPPORT",
  ADD_ALL_STUDENTS_EXTERNAL_SUPPORT_SUCCESS:
    "ADD_ALL_STUDENTS_EXTERNAL_SUPPORT_SUCCESS",
  ADD_ALL_STUDENTS_EXTERNAL_SUPPORT_ERROR:
    "ADD_ALL_STUDENTS_EXTERNAL_SUPPORT_ERROR"
}
